import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/lib/Form';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import CustomFormGroup from './CustomFormGroup';

const SelectGroup = (props) => (
  <div>
    <CustomFormGroup valid={props.valid}>
      {
        props.title!='' &&
        <ControlLabel>{props.title}</ControlLabel>
      }
      <FormControl
        id={props.setId}
        defaultValue={props.defaultValue}
        style={props.style}
        componentClass="select"
        placeholder={props.placeholder}
        onChange={props.controlFunc}>
        <option key='no_select' value="">{props.placeholder}</option>
        {props.options.map(opt => {
           return (
            <option
              key={opt[1]}
              value={opt[1]}>{opt[0]}</option>
            );
         })}
      </FormControl>
    </CustomFormGroup>
  </div>
);

SelectGroup.propTypes = {
  title: PropTypes.string.isRequired,
  setId: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  controlFunc: PropTypes.func.isRequired
};

export default SelectGroup;
